export function simpleError(message) {
    return {
        code: 'simple-error',
        message,
    };
}
//# sourceMappingURL=errors.js.map